import { createContext, useContext } from 'react';
import { ApiForecast } from 'src/api/queries';
import { CreateForecastPayload } from 'src/api/mutations';

export type ForecastingDataContextValue = {
  forecasts: {
    data: ApiForecast[] | undefined;
    isLoading: boolean;
    isError: boolean;
  };
  forecastComponentsAvailable: boolean;
  baselineSpend: Record<string, number>;
  isCheckingComponents: boolean;
  createForecast: (data: CreateForecastPayload) => Promise<void>;
  deleteForecast: (forecastId: string) => Promise<void>;
};

export const ForecastingDataContext =
  createContext<ForecastingDataContextValue | null>(null);

export function useForecastingDataContext() {
  const value = useContext(ForecastingDataContext);
  if (!value)
    throw new Error(
      'useForecastingDataContext must be used within ForecastingDataContextProvider',
    );
  return value;
}
